<template>
  <div>
    <CRow>
      <CCol sm="6">
        <CCard>
          <CCardHeader>
            <span :class="{'loading-card' : loading.card}"><strong>Deposit Credit</strong></span>
          </CCardHeader>
          <CForm novalidate>
            <CCardBody>
              <div :class="{'loading-card' : loading.card}"><CAlert show color="secondary"><small><i>1 SMS Credit seharga Rp {{ setting.credit_cost }}, Jumlah SMS Credit yang anda masukkan akan di kalkulasikan dengan harga Rp {{ setting.credit_cost }} / 1 SMS Credit, Contoh 2500 SMS Credit = 2500 x {{ setting.credit_cost }} = Rp {{ setting.credit_cost * 2500 }}</i></small></CAlert></div>
              <CAlert
                  color="danger"
                  closeButton
                  :show.sync="alert.show"
                >
                  {{ alert.content }}
                </CAlert>
              <CRow>
                <CCol md="6">
                  <div :class="{'loading-card' : loading.card}">
                    <CInput
                      type="number"
                      label="Jumlah Credit"
                      v-model="data.nominal"
                      :invalid-feedback="errors.nominal ? errors.nominal[0]:''"
                      :is-valid="errors.nominal ? false:null"
                    />
                  </div>
                </CCol>
                <CCol md="6">
                  <div :class="{'loading-card' : loading.card}">
                    <label for="">Metode Pembayaran</label>
                    <select class="form-control" :class="{ 'is-invalid' : errors.payment_id }" v-model="data.payment_id">
                      <option value="">-- Pilih --</option>
                      <option v-for="item in payment" :key="item.id" :value="item.id">{{ item.payment_name }}</option>
                    </select>
                    <div class="invalid-feedback" v-if="errors.payment_id">{{ errors.payment_id[0] }}</div>
                  </div>
                </CCol>
              </CRow>
            </CCardBody>
            <CCardFooter>
              <div :class="{'loading-card' : loading.card}">
                <ButtonLoader 
                  :loading="loading.submit" 
                  :styled="'btn btn-primary btn-block'" 
                  @click.native="submit()">
                    Deposit
                </ButtonLoader>
              </div>
            </CCardFooter>
          </CForm>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import $axios from './../api.js'
export default {
  name: 'Deposit',
  data(){
    return {
      alert:{
        show: false,
        content: ''
      },
      loading: {
        submit: false,
        card: true
      },
      payment: [],
      data:{
        nominal: '',
        payment_id: ''
      }
    }
  },
  created(){
    
  },
  computed:{
    ...mapState(['setting','errors'])
  },
  methods:{
    getPayment(){
      $axios.get('/payment')
      .then((response) => {
        this.loading.card = false
        this.payment = response.data.data
      }).catch((error) => {
        this.loading.card = false
      })
    },
    submit(){
      this.loading.submit = true
      this.$store.commit('CLEAR_ERRORS')
      this.alert = {
            show: false,
            content: ''
          }
      $axios.post('/deposit', this.data)
      .then((response) => {
        this.loading.submit = false
        this.$router.push('/history/deposit/'+response.data.data.id)
      }).catch((error) => {
        this.loading.submit = false
        if (error.response.status == 422) {
          this.$store.commit('SET_ERRORS', error.response.data.errors, { root: true })
        }else{
          this.alert = {
            show: true,
            content: error.response.data.message
          }
        }
      })
    }
  },
  mounted(){
    this.getPayment()
  }
}
</script>
